var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduledDuty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Duty Scheduled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.32,1.88a10.38,10.38,0,0,1-2.55-.13,5.85,5.85,0,0,1-3-1.57A1.92,1.92,0,0,0,7.59,0H7.41L7,.37A5.67,5.67,0,0,1,3.54,1.84c-.63,0-1.26,0-1.89,0-.28,0-.39.1-.39.38,0,2.18,0,4.37,0,6.55a4.88,4.88,0,0,0,1.15,3.1,9,9,0,0,0,4.83,3l.14.05h.24c.2-.06.41-.11.61-.18a8.93,8.93,0,0,0,4.34-2.89,5,5,0,0,0,1.16-2.78c0-.12,0-.24,0-.37V2.28C13.75,2,13.64,1.86,13.32,1.88Zm-2.68,8a3.33,3.33,0,0,1-3.47,2.28,3.36,3.36,0,0,1-3-3.21A4,4,0,0,1,5,6.14l.22-.25A2.45,2.45,0,0,0,6,8c-.43-2.1-.09-3.85,1.88-5a3.72,3.72,0,0,0-.11.41,1.63,1.63,0,0,0,.49,1.51,7.14,7.14,0,0,0,1,.83A3.57,3.57,0,0,1,10.64,9.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledDuty);
export default __webpack_public_path__ + "static/media/scheduled_duty.01d6fd3a53d29b252b02612ddb068379.svg";
export { ForwardRef as ReactComponent };